module.exports = __webpack_public_path__ + "static/media/TN-Women-Tops.cf9fb413.svg";